import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "name", "height", "width", "bordered", "shape", "alt"];
import { getImageUrl } from 'ui-images';
import { Image } from '../../../components/Image/Image';
import { jsx as _jsx } from "react/jsx-runtime";
export const Illustration = _ref => {
  let {
      disabled = false,
      name,
      height,
      width,
      bordered = false,
      shape = 'default',
      alt = `${name} illustration`
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const borderStyleProps = {
    borderBlockColor: 'text-core-default',
    borderInlineColor: 'text-core-default',
    borderBlockStyle: 'solid',
    borderInlineStyle: 'solid',
    borderBlockWidth: '100',
    borderInlineWidth: '100'
  };
  const circleShapeStyleProps = {
    borderStartStartRadius: 'full',
    borderStartEndRadius: 'full',
    borderEndStartRadius: 'full',
    borderEndEndRadius: 'full'
  };
  const roundedShapeStyleProps = {
    borderStartStartRadius: '100',
    borderStartEndRadius: '100',
    borderEndStartRadius: '100',
    borderEndEndRadius: '100'
  };
  const heightPx = typeof height === 'number' ? `${height}px` : height;
  const widthPx = typeof width === 'number' ? `${width}px` : width;
  return /*#__PURE__*/_jsx(Image, Object.assign({
    objectFit: "contain",
    src: getImageUrl(name, undefined),
    alt: alt,
    disabled: disabled
    // for review: is this conversion appropriate?
    ,
    inlineSize: widthPx,
    blockSize: heightPx,
    maxInlineSize: "100%"
  }, (shape === 'rounded' || shape === 'thumbnail') && roundedShapeStyleProps, shape === 'circle' && circleShapeStyleProps, bordered && borderStyleProps, rest));
};